import $ from "jquery";

//console.log("nac_desktop_b4ba.js running");

$('.nav_desktop_b4ba__dropdown_megas').slideUp(200);

// dropdown-mega
$('.nav_desktop_b4ba__menu .main_menu_item').on('mouseenter', function(){

  var $li = $(this);
  
  if($li.attr('data-dropdown-mega').length > 0 ) {

    var data_dropdown_mega = $li.attr('data-dropdown-mega');
    if($('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').length > 0){
    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas').slideDown(400);
    $('.bg-overlay').fadeIn(400);
    $('.theme_dark').addClass('temp_light_theme');
    $('.theme_dark').removeClass('theme_dark');
    console.log('data_dropdown_mega' + data_dropdown_mega);
    if(data_dropdown_mega == 1132){
      $('.applygrad').addClass('mega_gradient');
    }else{
      $('.applygrad').removeClass('mega_gradient');
    }
    } 
    else {
      $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
      $('.temp_light_theme').addClass('theme_dark');
      $('.temp_light_theme').removeClass('temp_light_theme');
      $('.nav_desktop_b4ba__dropdown_megas').slideUp(400);
      $('.bg-overlay').fadeOut(200);
          $('.applygrad').removeClass('mega_gradient');
    }
  }
});

// dropdown
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown')) {
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
    $li.addClass('show_dropdown');
  } else {
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  }
});

// leave nav
$('.nav_desktop_b4ba').on('mouseleave', function(){
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  $('.temp_light_theme').addClass('theme_dark');
  $('.temp_light_theme').removeClass('temp_light_theme');
  $('.nav_desktop_b4ba__dropdown_megas').slideUp(200);
  $('.bg-overlay').fadeOut(200);
});

$(window).scroll(function() {
  if ($( window ).width() < 1024){
    if($(window).scrollTop() > 20) {
          // $('.theme_dark').addClass('temp_light_theme');
          // $('.theme_dark').removeClass('theme_dark');
          $('.nav_desktop_b4ba__dropdown_megas').slideUp(0);
    }else{
      // $('.temp_light_theme').addClass('theme_dark');
      // $('.temp_light_theme').removeClass('temp_light_theme');
    }
  }
});


$(".removeClick").click(function(event){
  event.preventDefault();
});

//console.log("fade in active.. " + $('.split_hero').length);
  $('.split_hero').fadeTo( "200" , 1, function() {
  //console.log('Animation complete');
});


// spacer size
function setSpacerSize(){
  //console.log('setSpacerSize');
  var navHeight = $('.nav_desktop_b4ba').height();
  $('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})
}

setSpacerSize();

$(window).on('resize', function() {
  setSpacerSize();
});






